import { render, staticRenderFns } from "./inviteInfo.vue?vue&type=template&id=b84bb858"
import script from "./inviteInfo.vue?vue&type=script&lang=js"
export * from "./inviteInfo.vue?vue&type=script&lang=js"
import style0 from "./inviteInfo.vue?vue&type=style&index=0&id=b84bb858&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports